export const hungamaCointriesList = {
  AF: true,
  BD: true,
  BT: true,
  BN: true,
  KH: true,
  CN: true,
  IN: true,
  IR: true,
  IL: true,
  JP: true,
  KZ: true,
  KG: true,
  LA: true,
  MV: true,
  MN: true,
  MM: true,
  NP: true,
  KP: true,
  PK: true,
  PS: true,
  PH: true,
  RU: true,
  SG: true,
  KR: true,
  LK: true,
  SY: true,
  TW: true,
  TJ: true,
  TH: true,
  TL: true,
  TR: true,
  TM: true,
  UZ: true,
  VN: true,
};